module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$abs.row.pa > -1) ? _c('div', {
    staticClass: "abs-testo"
  }, [_c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.finanziamentiLabel,
      "prop": "finanziamenti"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.finanziamentiChange
    },
    model: {
      value: (_vm.finanziamenti),
      callback: function($$v) {
        _vm.finanziamenti = $$v
      },
      expression: "finanziamenti"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1), _vm._v(" "), ((_vm.finanziamenti == 1 && typeof _vm.$teras.evento.tipoeditor != 'undefined')) ? _c('el-form-item', {
    attrs: {
      "label": "Specificare quale"
    }
  }, [_c('tinymce', {
    attrs: {
      "initvalue": _vm.$abs.row.finanziamenti,
      "height": "300",
      "language": _vm.$teras.language
    },
    model: {
      value: (_vm.$abs.row.finanziamenti),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "finanziamenti", $$v)
      },
      expression: "$abs.row.finanziamenti"
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12bc00d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-finanziamenti.vue
// module id = 600
// module chunks = 2